import { Spacer } from "@nextui-org/spacer";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { Container, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

export default function UnauthorizedAccess() {
  return (
    <>
      <PageStaticMetaTags pageId="home" prerenderStatusCode={403} />
      <section className="section-404 absolute top-[50%] left-1/2 translate-x-[-50%] translate-y-[-50%] max-xs:p-2.5">
        <Container>
          <Text h1>403</Text>
        </Container>
        <Container>
          <Text h2>
            <Trans i18nKey="common:accessDenied.title" />
          </Text>
          <Spacer y={0.5} />
          <Text h4>
            <Trans i18nKey="common:accessDenied.message" />
          </Text>
        </Container>
      </section>
    </>
  );
}
